/*
 * @Author: your name
 * @Date: 2019-06-16 10:03:08
 * @LastEditTime : 2020-01-08 11:29:25
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \source\src\utility\tdtService\BusTransfer\Model\LinePlanItems.js
 */
import { CustomArray } from "../../../common/CustomArray";
import {LinePlanItem} from "./LinePlanItem";


export class LinePlanItems extends CustomArray {

	constructor() {
		super();
	}

	findById(id)
	{	
		let findItem=null;

		let tempItem=null;
		for(let tempIndex=0;tempIndex<this.objects.length;tempIndex++)
		{	
			tempItem=this.objects[tempIndex];
			if(tempItem && tempItem.id===id)
			{	
				findItem=tempItem;
				break;
			}
		}

		return findItem;
	}


	findIndexById(id)
	{	
		let findIndex=-1;

		let tempItem=null;
		for(let tempIndex=0;tempIndex<this.objects.length;tempIndex++)
		{	
			tempItem=this.objects[tempIndex];
			if(tempItem && tempItem.id===id)
			{	
				findIndex=tempIndex;
				break;
			}
		}

		return findIndex;
	}

	/**
	 * 重置选中状态
	 */
	resetSelectedStatus()
	{	
		let tempItem=null;
		for(let tempIndex=0;tempIndex<this.objects.length;tempIndex++)
		{	
			tempItem=this.objects[tempIndex];
			if(tempItem)
			{	
				tempItem.selectedStatus=false;
			}
		}
		
	}



	static GetLinePlanItems(jsonItems) {
		let planItems=new LinePlanItems();
		if(jsonItems==null)return planItems;
		

		let tempPlanItem=null;
		for (let tempIndex in jsonItems) 
		{	
			tempPlanItem = LinePlanItem.GetLinePlanItem(jsonItems[tempIndex]);
			planItems.push(tempPlanItem);
		}
		
		return planItems;
	}

}//end LinePlanItems

